module.exports = __webpack_public_path__ + "static/img/中邮证券.eef8da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/中邮证券.png
// module id = UIkr
// module chunks = 3